<template>
  <div>
    <div class="breadcrumb">
      <b>
        <router-link :to="'/general-settings'" style="color: #000">
          {{ enterpriseName }}
        </router-link>
      </b>
      <!-- <v-icon>keyboard_arrow_right</v-icon>
      <span class="crumb">
        <router-link
          v-if="$route.name"
          :to="$route.fullPath"
          style="color: #000"
        >
          {{ $route.name }}
        </router-link>
        <router-link v-else :to="$route.meta.parentUrl" style="color: #000">
          {{ $route.meta.parent }}
        </router-link>
      </span> -->
      <!-- <span v-if="crumb">
        <v-icon>keyboard_arrow_right</v-icon>
        <span class="crumb lastBread">
          <router-link :to="$route.fullPath" style="color: #000">
            {{ crumb }}
          </router-link>
        </span>
      </span> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["crumb"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState(["enterpriseName"]),
  },
};
</script>
